import { Link } from 'react-router-dom';
import { useMemo } from 'react';
import Header from '../../components/Public/Header';
import Footer from '../../components/Public/Footer';
import useUpdateTitle from '../../hooks/updateTitle';
import { PRIVACY_POLICY } from '../../utils/StaticVariable/policyContent';
import leftArrow from '../../icon/left.svg';

const PrivacyPolicyPage = () => {
  useUpdateTitle();
  const isDesktop = useMemo(() => window.innerWidth > 1200, []);

  return (
    <div className="flex min-h-screen flex-col bg-[#F8FAFC]">
      {isDesktop ? null : (
        <div className="sticky top-0 z-20 flex items-center gap-3 border-b border-[#E5E7EB] bg-white px-5 py-4">
          <Link to="/resume" className="inline-flex h-9 w-9 items-center justify-center rounded-full hover:bg-[#F3F4F6]" aria-label="이전으로 이동">
            <img src={leftArrow} alt="" className="h-5 w-5" />
          </Link>
          <div>
            <p className="text-[18px] font-[700] text-[#111827]">개인정보 처리방침</p>
            <p className="text-[12px] text-[#6B7280]">브이드림 서비스 전문보기</p>
          </div>
        </div>
      )}

      {isDesktop ? <Header /> : null}

      <main className="flex-1 px-4 py-6 md:px-8 md:py-10">
        <div className="mx-auto w-full max-w-[1120px] rounded-[24px] border border-[#E5E7EB] bg-white shadow-[0_10px_30px_rgba(15,23,42,0.06)]">
          <div className="sticky top-0 z-10 flex flex-col gap-4 border-b border-[#E5E7EB] bg-white/95 px-5 py-4 backdrop-blur md:flex-row md:items-center md:justify-between md:px-8 md:py-6">
            <div>
              <p className="text-[20px] font-[700] text-[#111827] md:text-[28px]">개인정보 처리방침</p>
              <p className="mt-1 text-[12px] text-[#6B7280] md:text-[14px]">브이드림 이력서 서비스 전문보기</p>
            </div>
            <div className="flex flex-wrap gap-2">
              <Link
                to="/resume/privacy-policy/revision"
                className="inline-flex items-center justify-center rounded-xl border border-[#16C1B1] bg-[#F4FBFA] px-4 py-2 text-[13px] font-[700] text-[#0F8F84] hover:bg-[#E8F8F6] md:px-5 md:py-2.5 md:text-[14px]"
              >
                이전 내용 보러가기
              </Link>
              <Link
                to="/resume"
                className="inline-flex items-center justify-center rounded-xl border border-[#D1D5DB] bg-white px-4 py-2 text-[13px] font-[600] text-[#374151] hover:bg-[#F9FAFB] md:px-5 md:py-2.5 md:text-[14px]"
              >
                메인으로
              </Link>
            </div>
          </div>

          <div className="px-4 py-5 md:px-8 md:py-8">
            {PRIVACY_POLICY}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
